<template>
  <div id="app">
    <!-- <el-menu mode="horizontal" router>
      <el-menu-item index="/">首页</el-menu-item>
    </el-menu> -->

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>